/**
 * Streamline Flex Solid icons (Free by Streamline)
 * Source: https://github.com/webalys-hq/streamline-vectors
 * License: CC BY 4.0 - https://streamlinehq.com
 */

import React from 'react';

const iconStyle = { width: '1em', height: '1em', flexShrink: 0 };

export function CogIcon({ size = 16, style = {}, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
      width={size}
      height={size}
      style={{ ...iconStyle, ...style }}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6.609 0.25h0.784a1.462 1.462 0 0 1 1.358 0.928l0.359 0.912 1.09 0.629 0.966 -0.147a1.462 1.462 0 0 1 1.484 0.715l0.391 0.676a1.46 1.46 0 0 1 -0.123 1.643l-0.61 0.763v1.262l0.606 0.763a1.464 1.464 0 0 1 0.123 1.643l-0.39 0.676a1.463 1.463 0 0 1 -1.484 0.715l-0.967 -0.147 -1.091 0.63 -0.357 0.91a1.462 1.462 0 0 1 -1.358 0.929h-0.783a1.462 1.462 0 0 1 -1.358 -0.929l-0.357 -0.91 -1.091 -0.63 -0.967 0.147a1.462 1.462 0 0 1 -1.484 -0.714l-0.39 -0.677a1.46 1.46 0 0 1 0.123 -1.643l0.61 -0.763V6.369l-0.61 -0.763a1.462 1.462 0 0 1 -0.124 -1.643l0.39 -0.676a1.462 1.462 0 0 1 1.485 -0.715l0.964 0.147 1.094 -0.634 0.359 -0.907A1.46 1.46 0 0 1 6.609 0.25ZM8.996 7c0 1.277 -0.719 1.996 -1.996 1.996 -1.277 0 -1.996 -0.719 -1.996 -1.996 0 -1.277 0.719 -1.996 1.996 -1.996 1.277 0 1.996 0.719 1.996 1.996Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export function TrophyIcon({ size = 16, style = {}, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
      width={size}
      height={size}
      style={{ ...iconStyle, ...style }}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M0.839008 0.900988C4.85911 -0.296385 9.141 -0.296382 13.1611 0.900993c0.4946 0.147317 0.8336 0.602067 0.8336 1.118127v1.49694c0 1.09157 -0.3531 2.16161 -1.0141 2.97052 -0.5239 0.64111 -1.2168 1.08565 -1.9908 1.24496 -0.0498 0.01025 -0.1005 0.01541 -0.1514 0.0154l-0.0484 -0.00001C10.3841 9.09715 9.35934 10.211 7.99487 10.581v1.9159h1.40364c0.41421 0 0.74999 0.3358 0.74999 0.75 0 0.4143 -0.33578 0.75 -0.74999 0.75H4.59082c-0.41422 0 -0.75 -0.3357 -0.75 -0.75 0 -0.4142 0.33578 -0.75 0.75 -0.75h1.40405v-1.9237c-1.34194 -0.3797 -2.37366 -1.49622 -2.78372 -2.82827l-0.05958 -0.00001c-0.05176 -0.00002 -0.10338 -0.00539 -0.15403 -0.01603 -0.76889 -0.16158 -1.45697 -0.60474 -1.97801 -1.24231C0.358477 5.67768 0.00538939 4.60764 0.0053876 3.51607v-0.00001L0.00537109 2.01912C0.00536543 1.50306 0.344413 1.0483 0.839008 0.900988ZM3.17379 1.8708c-0.11274 1.15251 -0.17135 2.39208 -0.17135 3.60871 0 0.23146 0.00227 0.46141 0.00671 0.68989 -0.29601 -0.12117 -0.5819 -0.3307 -0.82814 -0.63201 -0.42088 -0.51502 -0.67562 -1.24059 -0.67562 -2.02133v-0.00001l-0.00002 -1.24682c0.55161 -0.1569 1.10827 -0.28971 1.66842 -0.39843Zm7.81651 4.29886c0.0049 -0.22851 0.0075 -0.45857 0.0075 -0.69015 0 -1.21987 -0.0646 -2.45683 -0.1751 -3.60941 0.5614 0.10885 1.1192 0.24189 1.672 0.39914v1.24682c0 0.78074 -0.2547 1.50631 -0.6756 2.02133 -0.2464 0.30153 -0.5325 0.51114 -0.8288 0.63227Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export function CrownIcon({ size = 16, style = {}, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
      width={size}
      height={size}
      style={{ ...iconStyle, ...style }}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7 0.5625c-0.27307 0 -0.52375 0.150998 -0.65141 0.392381 -0.00344 0.006496 -0.00673 0.013066 -0.00988 0.019707L4.07339 5.75646c-0.17555 0.31836 -0.62159 0.34759 -0.83775 0.05799L1.70475 3.10561c-0.00744 -0.01318 -0.01548 -0.02601 -0.02409 -0.03845 -0.16351 -0.23637 -0.44124 -0.33518 -0.696689 -0.28163 -0.263751 0.05529 -0.488293 0.27205 -0.521267 0.58025C0.348408 4.43408 0.25 5.54714 0.25 6.6875c0 1.14035 0.098408 2.25341 0.212704 3.3217 0.179204 1.675 1.522616 3.0173 3.194566 3.2036 1.07385 0.1197 2.19441 0.2247 3.34273 0.2247s2.26888 -0.105 3.3427 -0.2247c1.672 -0.1863 3.0154 -1.5286 3.1946 -3.2036 0.1143 -1.06829 0.2127 -2.18135 0.2127 -3.3217 0 -1.14036 -0.0984 -2.25342 -0.2127 -3.32172 -0.033 -0.3082 -0.2575 -0.52496 -0.5213 -0.58025 -0.2554 -0.05355 -0.5332 0.04526 -0.6967 0.28163 -0.0086 0.01244 -0.0166 0.02527 -0.0241 0.03845l-1.5308 2.70884c-0.2162 0.2896 -0.6622 0.26037 -0.83778 -0.05799L7.66129 0.974588c-0.00315 -0.00664 -0.00644 -0.01321 -0.00988 -0.019705C7.52375 0.713497 7.27306 0.5625 7 0.5625Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export function HistoryIcon({ size = 16, style = {}, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
      width={size}
      height={size}
      style={{ ...iconStyle, ...style }}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7 0.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM7 2.5a.75.75 0 0 1 .75.75v3.44l2.03 2.03a.75.75 0 1 1-1.06 1.06l-2.25-2.25A.75.75 0 0 1 6.25 7V3.25A.75.75 0 0 1 7 2.5Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

// Calendar icon
export function CalendarIcon({ size = 16, style = {}, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
      width={size}
      height={size}
      style={{ ...iconStyle, ...style }}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4 0.5a.75.75 0 0 1 .75.75V2h4.5V1.25a.75.75 0 0 1 1.5 0V2h.75A2.5 2.5 0 0 1 14 4.5v7A2.5 2.5 0 0 1 11.5 14h-9A2.5 2.5 0 0 1 0 11.5v-7A2.5 2.5 0 0 1 2.5 2h.75V1.25A.75.75 0 0 1 4 0.5ZM1.5 6v5.5a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V6h-11Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

// Chevron Down icon
export function ChevronDownIcon({ size = 16, style = {}, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
      width={size}
      height={size}
      style={{ ...iconStyle, ...style }}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2.22 4.47a.75.75 0 0 1 1.06 0L7 8.19l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L2.22 5.53a.75.75 0 0 1 0-1.06Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

// Home icon
export function HomeIcon({ size = 16, style = {}, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
      width={size}
      height={size}
      style={{ ...iconStyle, ...style }}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6.293 0.793a1 1 0 0 1 1.414 0l5.5 5.5A1 1 0 0 1 12.5 8H12v4.5a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 2 12.5V8h-.5a1 1 0 0 1-.707-1.707l5.5-5.5ZM5.5 9a.5.5 0 0 1 .5.5v3.5h2V9.5a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 0 .5-.5V8a.5.5 0 0 0-.5-.5h-5A.5.5 0 0 0 3.5 8v.5a.5.5 0 0 0 .5.5h1.5Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

// Users/Team icon
export function UsersIcon({ size = 16, style = {}, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
      width={size}
      height={size}
      style={{ ...iconStyle, ...style }}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5 3.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm2 3.5a4 4 0 0 0-4 4v.5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V11a4 4 0 0 0-4-4Zm4.5-3a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm1.5 3a3 3 0 0 1 3 3v.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5V10a4.98 4.98 0 0 0-1-3h1Zm-11-3a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0ZM2 7a3 3 0 0 0-3 3v.5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V10a4.98 4.98 0 0 1 1-3H2Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

// Single User icon
export function UserIcon({ size = 16, style = {}, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
      width={size}
      height={size}
      style={{ ...iconStyle, ...style }}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7 0.5a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm0 7.5a5 5 0 0 0-5 5 .5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5 5 5 0 0 0-5-5Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

// Dice icon (for Draft)
export function DiceIcon({ size = 16, style = {}, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
      width={size}
      height={size}
      style={{ ...iconStyle, ...style }}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2 0.5A1.5 1.5 0 0 0 0.5 2v10A1.5 1.5 0 0 0 2 13.5h10a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 12 0.5H2ZM4 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm0 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm4-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm0 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

// Clipboard icon (for Rosters)
export function ClipboardIcon({ size = 16, style = {}, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
      width={size}
      height={size}
      style={{ ...iconStyle, ...style }}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5 0.5a1.5 1.5 0 0 0-1.415 1H2.5A1.5 1.5 0 0 0 1 3v9.5A1.5 1.5 0 0 0 2.5 14h9a1.5 1.5 0 0 0 1.5-1.5V3a1.5 1.5 0 0 0-1.5-1.5h-1.085A1.5 1.5 0 0 0 9 0.5H5Zm0 1.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1H5ZM4 7.25a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5A.75.75 0 0 1 4 7.25Zm.75 2.25a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5h-2.5Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

// Target icon (for Scoring)
export function TargetIcon({ size = 16, style = {}, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
      width={size}
      height={size}
      style={{ ...iconStyle, ...style }}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7 0.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM2.5 7a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0Zm2 0a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0ZM7 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

// Swap/Trade icon (two arrows exchange)
export function SwapIcon({ size = 16, style = {}, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
      width={size}
      height={size}
      style={{ ...iconStyle, ...style }}
      {...props}
    >
      <path
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2 4.75H10M8 2.75L10 4.75L8 6.75M12 9.25H4M6 7.25L4 9.25L6 11.25"
      />
    </svg>
  );
}

// Refresh/Sync icon (for Transactions)
export function RefreshIcon({ size = 16, style = {}, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
      width={size}
      height={size}
      style={{ ...iconStyle, ...style }}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7 1.5A5.5 5.5 0 0 0 1.5 7a.75.75 0 0 1-1.5 0 7 7 0 0 1 12.45-4.4V1.25a.75.75 0 0 1 1.5 0v3a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1 0-1.5h1.35A5.48 5.48 0 0 0 7 1.5ZM.05 9.75a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5H2.45A5.5 5.5 0 0 0 12.5 7a.75.75 0 0 1 1.5 0 7 7 0 0 1-12.45 4.4v1.35a.75.75 0 0 1-1.5 0v-3Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

// Warning icon
export function WarningIcon({ size = 16, style = {}, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
      width={size}
      height={size}
      style={{ ...iconStyle, ...style }}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6.134 1.066a1 1 0 0 1 1.732 0l5.5 9.5A1 1 0 0 1 12.5 12h-11a1 1 0 0 1-.866-1.5l5.5-9.5ZM7 4.5a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2A.75.75 0 0 1 7 4.5Zm0 5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

// Check/Success icon
export function CheckIcon({ size = 16, style = {}, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
      width={size}
      height={size}
      style={{ ...iconStyle, ...style }}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7 0.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13Zm3.03 4.72a.75.75 0 0 1 0 1.06l-3.5 3.5a.75.75 0 0 1-1.06 0l-1.5-1.5a.75.75 0 1 1 1.06-1.06L6 8.19l2.97-2.97a.75.75 0 0 1 1.06 0Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

// Close/X icon
export function CloseIcon({ size = 16, style = {}, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
      width={size}
      height={size}
      style={{ ...iconStyle, ...style }}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7 0.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13Zm2.53 3.97a.75.75 0 0 1 0 1.06L8.06 7l1.47 1.47a.75.75 0 1 1-1.06 1.06L7 8.06l-1.47 1.47a.75.75 0 0 1-1.06-1.06L5.94 7 4.47 5.53a.75.75 0 0 1 1.06-1.06L7 5.94l1.47-1.47a.75.75 0 0 1 1.06 0Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

// Chart/Stats icon
export function ChartIcon({ size = 16, style = {}, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
      width={size}
      height={size}
      style={{ ...iconStyle, ...style }}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M0.5 1.75a.75.75 0 0 1 1.5 0v9.5a.5.5 0 0 0 .5.5h10.75a.75.75 0 0 1 0 1.5H2.5A2 2 0 0 1 0.5 11.25v-9.5Zm3.5 6a.75.75 0 0 0-.75.75v2a.75.75 0 0 0 1.5 0v-2A.75.75 0 0 0 4 7.75Zm2.25-2.5a.75.75 0 0 1 1.5 0v5.25a.75.75 0 0 1-1.5 0V5.25Zm4.25-.5a.75.75 0 0 0-.75.75v5a.75.75 0 0 0 1.5 0v-5a.75.75 0 0 0-.75-.75Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

// Link icon
export function LinkIcon({ size = 16, style = {}, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
      width={size}
      height={size}
      style={{ ...iconStyle, ...style }}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7.879 1.121a3.5 3.5 0 0 1 4.95 4.95l-1.5 1.5a3.5 3.5 0 0 1-5.207-.207.75.75 0 1 1 1.106-1.014 2 2 0 0 0 2.976.118l1.5-1.5a2 2 0 0 0-2.828-2.828l-.75.75a.75.75 0 0 1-1.06-1.061l.75-.75.063-.058Zm-1.757 4.243a3.5 3.5 0 0 1 1.757.858.75.75 0 1 1-1.107 1.014 2 2 0 0 0-2.976-.118l-1.5 1.5a2 2 0 0 0 2.828 2.828l.75-.75a.75.75 0 0 1 1.06 1.06l-.75.75-.063.058a3.5 3.5 0 0 1-4.95-4.95l1.5-1.5a3.5 3.5 0 0 1 3.45-.75Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

// Plus icon
export function PlusIcon({ size = 16, style = {}, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
      width={size}
      height={size}
      style={{ ...iconStyle, ...style }}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7 0.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM7.75 4.25a.75.75 0 0 0-1.5 0v2h-2a.75.75 0 0 0 0 1.5h2v2a.75.75 0 0 0 1.5 0v-2h2a.75.75 0 0 0 0-1.5h-2v-2Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

// Minus icon (circle with horizontal line - matches Plus style)
export function MinusIcon({ size = 16, style = {}, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
      width={size}
      height={size}
      style={{ ...iconStyle, ...style }}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7 0.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM4.25 6.25a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5h-5.5Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

// Subtract icon (horizontal line only - for drop button)
export function SubtractIcon({ size = 12, style = {}, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 12 12"
      width={size}
      height={size}
      style={{ ...iconStyle, ...style }}
      {...props}
    >
      <path fill="currentColor" d="M2 5.5h8v1H2z" />
    </svg>
  );
}

// Scoreboard/Grid icon
export function ScoreboardIcon({ size = 16, style = {}, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
      width={size}
      height={size}
      style={{ ...iconStyle, ...style }}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M1.5 0.5A1.5 1.5 0 0 0 0 2v2.5a1.5 1.5 0 0 0 1.5 1.5H4A1.5 1.5 0 0 0 5.5 4.5V2A1.5 1.5 0 0 0 4 0.5H1.5Zm0 7.5A1.5 1.5 0 0 0 0 9.5V12A1.5 1.5 0 0 0 1.5 13.5H4A1.5 1.5 0 0 0 5.5 12V9.5A1.5 1.5 0 0 0 4 8H1.5ZM8 2a1.5 1.5 0 0 1 1.5-1.5H12A1.5 1.5 0 0 1 13.5 2v2.5A1.5 1.5 0 0 1 12 6H9.5A1.5 1.5 0 0 1 8 4.5V2Zm1.5 6A1.5 1.5 0 0 0 8 9.5V12A1.5 1.5 0 0 0 9.5 13.5H12A1.5 1.5 0 0 0 13.5 12V9.5A1.5 1.5 0 0 0 12 8H9.5Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

// Players icon (like a roster with people)
export function PlayersIcon({ size = 16, style = {}, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
      width={size}
      height={size}
      style={{ ...iconStyle, ...style }}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3.5 2a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm1.5 3a2.5 2.5 0 0 0-2.5 2.5v.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5V7.5A2.5 2.5 0 0 0 5 5Zm4.5-3a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm1.5 3a2.5 2.5 0 0 0-2.5 2.5v.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5V7.5A2.5 2.5 0 0 0 11 5ZM2 10.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-2Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

// Search/Magnifying Glass icon
export function SearchIcon({ size = 16, style = {}, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
      width={size}
      height={size}
      style={{ ...iconStyle, ...style }}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6 1.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9ZM0 6a6 6 0 1 1 10.69 3.75l2.78 2.78a.75.75 0 1 1-1.06 1.06l-2.78-2.78A6 6 0 0 1 0 6Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

// Filter icon
export function FilterIcon({ size = 16, style = {}, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
      width={size}
      height={size}
      style={{ ...iconStyle, ...style }}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M0.5 2.75A.75.75 0 0 1 1.25 2h11.5a.75.75 0 0 1 0 1.5H1.25A.75.75 0 0 1 0.5 2.75Zm2 4A.75.75 0 0 1 3.25 6h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 2.5 6.75Zm2 4a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

// Bell/Notification icon
export function BellIcon({ size = 16, style = {}, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
      width={size}
      height={size}
      style={{ ...iconStyle, ...style }}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7 0.5a.75.75 0 0 1 .75.75v.585A4.501 4.501 0 0 1 11.5 6v2.379l.854.854A.5.5 0 0 1 12 10H2a.5.5 0 0 1-.354-.854l.854-.854V6A4.5 4.5 0 0 1 6.25 1.585V1.25A.75.75 0 0 1 7 0.5Zm-1.5 11a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

// Baseball icon (for the app)
export function BaseballIcon({ size = 16, style = {}, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
      width={size}
      height={size}
      style={{ ...iconStyle, ...style }}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7 0.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM2.05 5.5a5.01 5.01 0 0 1 2.2-3.15c-.1.38-.17.77-.2 1.16a6.53 6.53 0 0 0 .45 2.99H2.05Zm0 3h2.45a6.53 6.53 0 0 1-.45 2.99c.03.39.1.78.2 1.16a5.01 5.01 0 0 1-2.2-3.15Zm3.7 4.45A5.02 5.02 0 0 0 7 13c.43 0 .85-.05 1.25-.15.1-.38.17-.77.2-1.16a6.53 6.53 0 0 0-.45-2.99 6.53 6.53 0 0 0-.45 2.99c.03.39.1.78.2 1.16-.4.1-.82.15-1.25.15a5.02 5.02 0 0 1-1.25-.15Zm6.2-4.45a5.01 5.01 0 0 1-2.2 3.15c.1-.38.17-.77.2-1.16a6.53 6.53 0 0 0-.45-2.99h2.45Zm0-3h-2.45a6.53 6.53 0 0 1 .45-2.99c-.03-.39-.1-.78-.2-1.16a5.01 5.01 0 0 1 2.2 3.15Zm-3.7-4.45A5.02 5.02 0 0 0 7 1c-.43 0-.85.05-1.25.15-.1.38-.17.77-.2 1.16a6.53 6.53 0 0 0 .45 2.99 6.53 6.53 0 0 0 .45-2.99c-.03-.39-.1-.78-.2-1.16.4-.1.82-.15 1.25-.15.43 0 .85.05 1.25.15Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

// Copy icon
export function CopyIcon({ size = 16, style = {}, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
      width={size}
      height={size}
      style={{ ...iconStyle, ...style }}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3 0.5A1.5 1.5 0 0 0 1.5 2v7A1.5 1.5 0 0 0 3 10.5h.5V11A1.5 1.5 0 0 0 5 12.5h6A1.5 1.5 0 0 0 12.5 11V4A1.5 1.5 0 0 0 11 2.5h-.5V2A1.5 1.5 0 0 0 9 0.5H3ZM9 2.5V2H3v7h.5V4A1.5 1.5 0 0 1 5 2.5h4Zm-4 2v6.5h6V4H5Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

// Standings/Podium icon
export function StandingsIcon({ size = 16, style = {}, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
      width={size}
      height={size}
      style={{ ...iconStyle, ...style }}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5.5 0.5a.5.5 0 0 0-.5.5v5.5H1a.5.5 0 0 0-.5.5v5.5a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5H9V1a.5.5 0 0 0-.5-.5h-3Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

// Resend/Mail icon
export function MailIcon({ size = 16, style = {}, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
      width={size}
      height={size}
      style={{ ...iconStyle, ...style }}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M0 3.5A1.5 1.5 0 0 1 1.5 2h11A1.5 1.5 0 0 1 14 3.5v7a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 0 10.5v-7Zm1.872.218a.75.75 0 0 0-.744 1.302l5.5 3.143a.75.75 0 0 0 .744 0l5.5-3.143a.75.75 0 0 0-.744-1.302L7 6.832 1.872 3.718Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

// Trash/Delete icon (for Drop player)
export function TrashIcon({ size = 16, style = {}, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
      width={size}
      height={size}
      style={{ ...iconStyle, ...style }}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5 1.5a.5.5 0 0 0-.5.5v.5h-2a.75.75 0 0 0-.75.75v8.5c0 .414.336.75.75.75h9a.75.75 0 0 0 .75-.75v-8.5a.75.75 0 0 0-.75-.75h-2v-.5a.5.5 0 0 0-.5-.5H5Zm1.5 1v-.5h1v.5h-1Zm-2.25 2h7.5v7h-7.5v-7Zm1.5 1.25a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 1 0v-4a.5.5 0 0 0-.5-.5Zm2 0a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 1 0v-4a.5.5 0 0 0-.5-.5Zm2 0a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 1 0v-4a.5.5 0 0 0-.5-.5Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

// Play icon (triangle - for Resume)
export function PlayIcon({ size = 16, style = {}, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
      width={size}
      height={size}
      style={{ ...iconStyle, ...style }}
      {...props}
    >
      <path
        fill="currentColor"
        d="M3.5 2.134a1 1 0 0 1 1.506-.864l7 4.116a1 1 0 0 1 0 1.728l-7 4.116A1 1 0 0 1 3.5 10.366V2.134Z"
      />
    </svg>
  );
}

// Pause icon (two bars - for Pause Draft)
export function PauseIcon({ size = 16, style = {}, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
      width={size}
      height={size}
      style={{ ...iconStyle, ...style }}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3 1.5A1.5 1.5 0 0 0 1.5 3v8A1.5 1.5 0 0 0 3 12.5h1A1.5 1.5 0 0 0 5.5 11V3A1.5 1.5 0 0 0 4 1.5H3Zm7 0A1.5 1.5 0 0 0 8.5 3v8a1.5 1.5 0 0 0 1.5 1.5h1a1.5 1.5 0 0 0 1.5-1.5V3A1.5 1.5 0 0 0 11 1.5h-1Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

// Info icon
export function InfoIcon({ size = 16, style = {}, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
      width={size}
      height={size}
      style={{ ...iconStyle, ...style }}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7 0.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM7 4a.75.75 0 1 0 0 1.5A.75.75 0 0 0 7 4Zm.75 3.25a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 0 1.5 0v-2.5Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
